var Backbone = require('backbone'),
    BasePage = require('./basePg.js'),
    _ = require('underscore'),
    PagePositionalTextModel = require('./pgPositionalTextModel/model');


module.exports = BasePage.extend({

    typeIdentifier: 'DOC_MODE',
    SPIN_JS_OPTS: { top: '15%', length: 6, radius: 6, width: 2, lines: 13 },

    /**
     * Unlike thumbnail, based on fixed ht and width for the expected non-renderable placeholder.
     * Note: this is diff than unknown -- for non-renderable placeholder.
     * Note: height is arbitrary -- will be set by docModeImageWidthFn parameter (unless set it explicity)
     * I think width is also arbitrary
     */
    nonRenderableOrigDimensions: {
        w: 200,
        h: 200
    },

    unknownOrigDimsDimensions: BasePage.prototype.STANDARD_PG_DIMS,

    /**
     * Store docModeImageWidthFn once -- used in getSetWidth.
     * Only store positionalTextDataModel on Doc Mode pages -- can be referenced via the pages Collection on the active document
     */
    constructor: function(attrs, options) {

        this.positionalTextDataModel = null;
        this.docModeImageWidthFn = options.docModeImageWidthFn;

        BasePage.prototype.constructor.apply(this, arguments);

    },

    // This works  but you need to update the derived dimensions on rotate
    // do only for renderable pages / rotatable pages ... ???
    parse: function(attrs) {

        // the original is called first -- hack in change below ...
        attrs = BasePage.prototype.parse.apply( this, arguments );


        // Note: returns null from server if doesn't exist
        if ( attrs.ocrNote ) {

            this.positionalTextDataModel = new PagePositionalTextModel( attrs.ocrNote, {
                parse: true,
                pageNumber: attrs.number,
                pageId: attrs.pageId,
                fddPageOriginalImageProperties: attrs.originalImageProperties
            });

        }

        // keep rotated 'derived' width at max of 1000 -- we request with the actual ...
        var r = attrs.rotation;

        // Get the what would be be the visible dimensions if printed with rotation

        var rw = attrs.width,
            rh = attrs.height;

        if ( r === 90 || r === 270 ) {
            rw = attrs.height;
            rh = attrs.width;
        }

        var setWidth = this._getSetWidth();

        // we just want it so width is not requested > MAX
        // ( we don't want anything > a max width ) --  this resolves problems with fit width scaling ...
        if ( rw > setWidth ) {

            var rar = rw / rh; // do the calc at the current rotation ... maybe do on the actual width and height, non rotated ...
            var nw = setWidth; // get a new width
            var nh = Math.round( nw / rar );  // derive its new height from the original aspect ratio

            // now unrotate if need be -- this also seems to work ... should do based off the original aspect ratio
            // better refactor would be getting rid of the first part ... where the non rotated width is already maxed out at set width ...
            // so we only update if rotated ...
            if ( r === 90 || r === 270 ) {

                attrs.width = nh;
                attrs.height = nw;
            }

        }

        return attrs;

       // alternatively, after all pages parse, get the max width and apply that ... don't want any bigger than another ? ... that could be cleaner

    },

    /**
     * Note: this can be dynamic so needs a fn to pass in that gets value from viewer
     * TODO: I don't think we care about the max of the container width now and 1000
     * --- could just say max of 1000 ... and max.min ( return Math.min( width, 1000 );
     */
    _getSetWidth: function() {
        return this.docModeImageWidthFn();
    },
    /**
     * Really the derived height from the original width of the image and the width of it's container -- (takes rotation into account)
     * Should optimize the calc: cache and then only update on rotation change
     */
    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {

        if ( !isRenderable )
            return this.nonRenderableOrigDimensions.h;

        var originalDimensions = attrs.originalImageProperties // ( only exists for FDD image -- TODO: may be better to check page type for fixtures that diverged since change )
            ? {
                w: attrs.originalImageProperties.width,
                h: attrs.originalImageProperties.height
            }
            : this.unknownOrigDimsDimensions; // this will be set post load ( updateUnknownDimensionsPostLoad )


        // Basically calc to fit to the size of the container
        var ar = originalDimensions.w / originalDimensions.h;
        return Math.round( this._getSetWidth() / ar );

    },

    updateUnknownDimensionsPostLoad: function(loadDimensions) {

        var containerWidth = this.docModeImageWidthFn(),
            imgWtToContainerWidthRatio = containerWidth / loadDimensions.width,
            h =  Math.round( loadDimensions.height * imgWtToContainerWidthRatio);

        this.set({
           width: containerWidth,
           height: h
        });

    },

    // This allows for requesting with the correct aspect ratio given then adjustment made
    // to keep a max width for all pages, given they can be rotated but the non rotated image is requested
    _getFixedWidthForImgRenderRequest: function() {
        return this.getRotatedWidth();
    },

    setRotation: function( rotation ) {

        BasePage.prototype.setRotation.call( this, rotation );

        // TODO: better way here --
        // for this mode reset the height / width ( which are set on parse) in case the rotate width would be greater than the 'max width'

        this.parse( this.attributes, {
            parentDocument: this.get('parentDocument'),
            imageFileType: this.get('imageFileType')
        } );
    },

    /* -- positional text data model -- */

    getPositionalTextDataModel: function() {

        return this.positionalTextDataModel;

    },

    hasPositionalTextData: function() {

        return this.getPositionalTextDataModel() !== null;

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgDocMode.js
 ** module id = 344
 ** module chunks = 0
 **/